import { buildSeriesTimelineRows } from './seriesTimeline';
import { IsFirstFollowupEarmoldEligibleParams } from '../types';

export function isFirstFollowupEarmoldEligible(params: IsFirstFollowupEarmoldEligibleParams): boolean {
  const { isFollowUpServiceSelected, seriesData, nowMs } = params;

  if (!isFollowUpServiceSelected) {
    return false;
  }

  if (seriesData === null) {
    return false;
  }

  const rows = buildSeriesTimelineRows({
    events: seriesData.events,
    rootEventId: seriesData.series.rootEventId,
    nowMs,
  });

  const followUpCount = rows.filter((row) => row.followUpSeq !== null).length;

  return followUpCount === 0;
}
